/**
 * Frame for the full-height planning views (Gantt, Team, Bezetting): fills the
 * shell's content area (the view scrolls internally) and waits for the
 * planning store.
 */
import type { ReactNode } from 'react';
import { ActivePlanningGate } from '../lib/activePlanning.js';
import { useDocumentTitle } from '../lib/prefs.js';
import styles from './AppShell.module.css';

export function ViewFrame({ title, children }: { title: string; children: ReactNode }) {
  useDocumentTitle(title);
  return (
    <div className={styles.viewFrame}>
      <ActivePlanningGate>{children}</ActivePlanningGate>
    </div>
  );
}
